import React from 'react';
import { TemplateManagementRoute } from '../../routes';
import { Route } from 'react-router';
import { useFeatureFlags } from 'core/app/AppContext';

export const TemplateCopyEditorPage: React.FC = () => {
  const { flagEnabled } = useFeatureFlags();

  return (
    <>
      {flagEnabled('ld-copy-editor') && (
        <Route path={TemplateManagementRoute.EDIT_COPY}>
          <h1>New Template Copy Editor</h1>
        </Route>
      )}
    </>
  );
};

export default TemplateCopyEditorPage;
